import React, {useState, useEffect} from 'react';
import {Link} from 'react-router-dom';
import ReactPaginate from 'react-paginate';
import axios from 'axios';
import Header from "../../../components/layout/Header";
import Wrapper from "../../../components/layout/Wrapper";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faBook,
    faCode, faCoins, faFaceLaugh, faFire, faGear, faHandPaper,
    faHome,
    faMoneyBill,
    faPencil, faPerson, faTable,
    faTablet,
    faTrophy,
    faUniversity
} from '@fortawesome/free-solid-svg-icons';
import Footer from "../../../components/layout/Footer";
import {Helmet} from "react-helmet-async";
import Breadcrumb from "../../../components/layout/Breadcrumb";
import ProgressBar from "../../../components/elements/ProgressBar";
import ButtonLink from "../../../components/elements/ButtonLink";
import AccountMenu from "../AccountMenu";


const MyCourses = () => {

    const breadC = [
        {title: 'حساب‌کاربری', link: '#'},
        {title: 'دوره‌های من', link: '/account/course'},
    ];

    return (
        <>
            <div className='min-h-screen flex flex-col'>
                <Header/>
                <main className='flex-1 my-8'>
                    <Wrapper>
                        <div>
                            <div className='w-full flex flex-1 gap-x-10'>
                                <div className='w-1/5'>
                                    <div
                                        className='w-full border-2 border-gray-200 text-lg font-bold rounded-md bg-gray-100 p-10 flex justify-center items-center flex-col mb-5'>
                                        <div className='w-48 h-48 rounded-full relative bg-gray-200'>
                                            <div
                                                className='absolute left-3 top-3 border-b-4 w-12 h-12 transition hover:bg-gray-900 active:border-b-0 border-gray-900 bg-gray-700 p-3 cursor-pointer rounded-full flex justify-center items-center z-1'>
                                                <FontAwesomeIcon icon={faPencil} size='md' className='text-white'/>
                                            </div>
                                        </div>
                                        <span className='text-lg block font-bold mt-5'>مهدیار ایرانی قمی</span>
                                        <span className='text-md block font-bold mt-3 text-gray-700'>09939484977</span>
                                    </div>
                                    <div
                                        className='w-full border-2 border-gray-200 text-lg font-bold rounded-md bg-gray-100 flex items-center mb-5'>
                                        <div
                                            className='w-1/3 border-l-2 flex justify-center items-center gap-x-3 border-gray-200 p-5'>
                                            <span>۱۰۰۰</span>
                                            <FontAwesomeIcon icon={faCoins} size='md'/>
                                        </div>
                                        <div
                                            className='w-1/3 border-l-2 flex justify-center items-center gap-x-3 border-gray-200 p-5'>
                                            <span>۵</span>
                                            <FontAwesomeIcon icon={faFire} size='md'/>
                                        </div>
                                        <div className='w-1/3 flex justify-center items-center gap-x-3'>
                                            <span>۵۰۰</span>
                                            <FontAwesomeIcon icon={faPerson} size='md'/>
                                        </div>
                                    </div>
                                    <AccountMenu />
                                </div>
                                <div className='w-4/5'>
                                    <Breadcrumb items={breadC} wrapper={false}/>
                                    <div className='flex flex-wrap gap-x-8'>
                                        <div className='w-1/3 border-4 border-gray-200 rounded-md p-5'>
                                            <h2 className='text-xl font-bold mb-5 text-gray-700'>دوره HTML جامع</h2>
                                            <ProgressBar value={2} max={30}/>
                                            <div className='flex mt-5 flex-1 justify-between items-center gap-x-3'>
                                                <div className='w-1/2'>
                                                    <ButtonLink to={'/account/course/HTML/content'} className='gap-x-2 w-full'>
                                                        <FontAwesomeIcon icon={faBook} size='lg' />
                                                        <span className='font-bold'>درسنامه</span>
                                                    </ButtonLink>
                                                </div>
                                                <div className='w-1/2'>
                                                    <ButtonLink to='/account/course/HTML/cheatsheet' className='gap-x-2 w-full'>
                                                        <FontAwesomeIcon icon={faHandPaper} size='lg' />
                                                        <span className='font-bold'>تقلب‌نامه</span>
                                                    </ButtonLink>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Wrapper>
                </main>
                <Footer/>
            </div>
        </>
    );
};

export default MyCourses;
